export default "__VITE_ASSET__CIIQiSJ8__"